import O from "./O";
import ContextMenu from "./ContextMenu";
import { useState } from 'react';
import { xor } from './utils';
/*
function getImagesSlotIdsByNodeId(node,images,channelGroupStructure){



  let channelGroups = template.compact.channelGroupStructure.flat()
  let imagesByNodeId = Object.fromEntries(nodeIds.map(nodeId => ([nodeId,[]])))


  //all image slots...
  //and whatever has THIS channelGroup
  //
  let { channelGroup } = node;


  Object.entries(images).forEach(([imageSlotId,value]) => {
    let { placements = [] } = value;
    placements.forEach(nodeId => {
      imagesByNodeId[nodeId].push(imageSlotId)
    })
  })

  return imagesByNodeId;
}
*/


export default function ExpansionPreviewContextMenu({
  imageIdsByChannel,

  setRegionAssignments,
    regionAssignments,
    focusedRegionId,
  pos,
  regionList,


  node,
  template,
  onEvent,




}){

  const [ openPath, setOpenPath ] = useState([]);

  let { channels, channelGroups } = template.compact;

  let channelGroupId = node.value.channelGroup;

  let channelSubmenu = Object.entries(channels).map(([channelId,channel]) => {

    let channelGroup =  channelGroups[channelGroupId]

    let disabled = !imageIdsByChannel[channelId];
    let checked = channelGroup.includes(channelId);

    return {title:(
      <div class="sg-row v-center">



        <input disabled={disabled} 
          key={channelGroup.join('-')} 
        style={{
          pointerEvents:'auto',
        }} type="checkbox" 
        checked={checked} 
        onChange={() => {

          let oldGroup = channelGroups[channelGroupId]
          let newGroup = xor(oldGroup,channelId);

          console.log({
            oldGroup,
          })
          
          let properties = {
            [`compact.channelGroups.${channelGroupId}`]:newGroup,
            [`channelGroups.${channelGroupId}`]:newGroup

          }

          onEvent({
            type:"templateChange",
            properties,
          })



          console.log({oldGroup,newGroup});


        }}/>

        <div style={{
          minWidth:15,
          height:15,
          borderRadius:15,
          background:channel.color,
          border:'1px solid #ccc',
          marginLeft:5,
          marginRight:5,
        }}/>

        <div style={{
          whiteSpace:'nowrap',
        }}>{channel.label || "Channel " + channel.defaultValue}</div>

      </div>
    ),
      ignore:true,
    }

  })

  let cm = (x,y) =>  <ContextMenu onEvent={e => {
    let { _id } = e;
    setRegionAssignments({
      ...regionAssignments,
      [focusedRegionId]:_id,
    })
    debugger;
  }} setOpenPath={setOpenPath} 
    treeLevel={0} 
    openPath={openPath} 
    x={x} 
    y={y}
    transform={'translate(-50%, -100%)'}
    items={[
      {
        title:<b>Channels</b>,
        submenu:channelSubmenu,
        ignore:true,
      },
      ...regionList
    ]}
    />


  return (
    <div style={{
      position:'absolute',
      zIndex:999999999999999
    }} class="sg-row">
      {cm(...pos)}

      
    </div>
  )

}
